export default __webpack_public_path__ + "static/media/main.373fcd23.jpg";